module.exports = __webpack_public_path__ + "static/1-432f31710ff10978e29fb1b815515f35.png";